export class Format {
  static Number = (val, toFixed = 0, max = 99999999) => {
    let a = val;
    let num = Number(toFixed);
    let str = val.toString();
    let idx = str.lastIndexOf(".");
    if (idx > -1) {
      let str_idx = str.length - idx;
      if (str_idx > num + 1) {
        a = Number(val).toFixed(num);
      }
    } else {
      a = Number(val);
    }
    if (a > max) {
      a = max;
    }
    return a;
  };
}

export class SelectCheck {
  constructor(key = "id", mode = "multiple") {
    this.key = key;
    this.mode = mode;
    this.isAgain = false; //在单选模式中，如果开启，则取消选中
    this.checkAll = {
      isAll: false,
      indeterminate: false,
      cur: 0,
      checkPage: [],
      disabled: false,
    };
    this.dataSource = [];
    this.tableData = [];
    this.selectKeys = [];
    this.selectObjs = [];

    this.checkValue = () => {
      let idx = this.checkAll.cur;
      let checkpage = this.checkAll.checkPage;
      let a = checkpage[idx]?.isAll;
      return a;
    };
    this.checkIndeterminate = () => {
      let idx = this.checkAll.cur;
      let checkpage = this.checkAll.checkPage;
      let a = checkpage[idx]?.indeterminate;
      return a;
    };
    this.selectAdd = (record = {}) => {
      this.selectKeys.push(record[this.key]);
      this.selectObjs.push(record);
      this.selectIsAll();
    };
    this.selectDel = (idx) => {
      this.selectKeys.splice(idx, 1);
      this.selectObjs.splice(idx, 1);
      this.selectIsAll();
    };
    this.selectUpdate = (list, pageTotal = 1) => {
      //初始化列表 及 选择状态表
      //传入原始数组，如果有页码，刚传入页码。如果没页码默认为1，
      let pageNum = pageTotal;
      let dataSource = list || [];
      if (!dataSource.length) {
        this.checkAll.disabled = true;
      } else {
        this.checkAll.disabled = false;
      }

      this.checkAll.cur = Number(pageNum) - 1;
      let checkPage = this.checkAll.checkPage;
      let min = checkPage.length; //0
      let max = pageNum - min; // 1- 0
      if (pageNum > min) {
        for (let i = 0; i < max; i++) {
          checkPage.push({ isAll: false, indeterminate: false });
        }
      }
      this.checkAll.checkPage = checkPage;
      this.dataSource = dataSource;
      this.selectIsAll();
    };
    this.selectReset = () => {
      //重置选择
      this.checkAll.cur = 0;
      this.checkAll.checkPage = [];
      this.checkAll.isAll = false;
      this.checkAll.indeterminate = false;
      this.selectKeys = [];
      this.selectObjs = [];
    };
    this.onChange = (record = {}) => {
      console.log("record", record);
      if (record.disabled) {
        return false;
      }

      if (this.mode === "multiple") {
        const idx = this.selectKeys.indexOf(record[this.key]);
        if (idx > -1) {
          //删除
          this.selectDel(idx);
          return false;
        } else {
          //添加
          this.selectAdd(record);
          return false;
        }
      }
      if (this.mode === "combobox") {
        const idx = this.selectKeys.indexOf(record[this.key]);
        if (idx > -1) {
          //删除
          if (this.isAgain) {
            //如果已选中，则取消选中
            this.selectDel(idx);
          }
          return false;
        } else {
          ////单选直接替换值
          this.selectKeys[0] = record[this.key];
          this.selectObjs[0] = record;
        }
      }
    };

    this.onCheckAll = (listData = []) => {
      let a = this.checkAll.checkPage[this.checkAll.cur]?.isAll;
      let b = this.checkAll.checkPage[this.checkAll.cur]?.indeterminate;
      if (listData.length === 0) {
        //列表为空时，设置为未选择
        this.setStatus(1);
        return false;
      }
      if ((a && !b) || (a && b)) {
        //取消选择
        for (let i in listData) {
          let record = listData[i];
          if (this.selectKeys.includes(record[this.key])) {
            const idx = this.selectKeys.indexOf(record[this.key]);
            if (idx > -1) {
              this.selectDel(idx);
            }
          }
        }
        this.setStatus(1);
        return false;
      }
      if (!a && !b) {
        //全部选择
        for (let i in listData) {
          let record = listData[i];
          if (!this.selectKeys.includes(record[this.key])) {
            this.selectAdd(record);
          }
        }
        this.setStatus(3);
        return false;
      }
    };
  }
  selectIsAll() {
    let dataSource = this.dataSource;
    //判断当前页面是否全部选中
    let count = 0;
    for (let i in dataSource) {
      if (this.selectKeys.includes(dataSource[i][this.key])) {
        count += 1;
      }
    }
    if ((count === 0 && dataSource.length > 0) || dataSource.length === 0) {
      //如果列表条数> 0,count = 0时 设置未选择。或者 列表条数 == 0时，设置未选择
      this.setStatus(1);
      return false;
    }
    if (count > 0 && count !== dataSource?.length) {
      this.setStatus(2);
      return false;
    }
    if (count === dataSource?.length) {
      this.setStatus(3);
      return false;
    }
  }
  setStatus(type = 1) {
    if (type === 1) {
      //未选择
      this.checkAll.checkPage[this.checkAll?.cur].isAll = false;
      this.checkAll.checkPage[this.checkAll?.cur].indeterminate = false;
    }
    if (type === 2) {
      //部分选择
      this.checkAll.checkPage[this.checkAll?.cur].isAll = true;
      this.checkAll.checkPage[this.checkAll?.cur].indeterminate = true;
    }
    if (type === 3) {
      //全部选择
      this.checkAll.checkPage[this.checkAll?.cur].isAll = true;
      this.checkAll.checkPage[this.checkAll?.cur].indeterminate = false;
    }
  }
}
import { Loading } from "element-ui";
export class PageList extends SelectCheck {
  constructor() {
    super();
    this.clearValidate = () => { };
    this.loading = true;
    this.page = {
      layout: "prev, pager, next",
      pageNum: 1,
      pageSize: 20, //每页的数量
      total: 0,
      totalPage: 0,
      startIndex: 0,
      endIndex: 10,
      updateIndex: (index) => {
        let a =
            (this.page.pageNum - 1) * this.page.pageSize + Number(index + 1);
        return a;
      },
      updateList: () => {
        this.clearValidate();
        //延迟1000毫秒以下，没什么效果。
        //const loading = Loading.service({ body: true, fullscreen: true, lock: true })
        this.page.startIndex = (this.page.pageNum - 1) * this.page.pageSize;
        this.page.endIndex = this.page.pageNum * this.page.pageSize;
        let count = 0;
        this.tableData = [];
        for (let i in this.dataSource) {
          if (i >= this.page.startIndex && i < this.page.endIndex) {
            this.tableData[count] = this.dataSource[i];
            count += 1;
          }
          if (i >= this.page.endIndex) {
            break;
          }
        }

        this.loading = false;
        // setTimeout(() => {
        //     loading.close()
        // }, 1000);
      },
      pageChange: ($event) => {
        this.page.pageNum = $event;
        this.page.updateList();
      },
      prevClick: () => {
        this.page.pageNum -= 1;
        this.page.updateList();
      },
      nextClick: () => {
        this.page.pageNum += 1;
        this.page.updateList();
      },
      sizeChange: ($event) => {
        this.page.pageSize = $event;
        this.page.pageNum = 1;
        this.page.updateTotalPage();
        this.page.updateList();
      },
      updateTotalPage: () => {
        this.page.total = this.dataSource.length;
        this.page.totalPage = Math.ceil(this.page.total / this.page.pageSize);
      },
      update: (pageNum = this.page.pageNum) => {
        this.page.pageNum = pageNum;
        this.page.updateTotalPage();
        this.page.updateList();
      },
    };
    this.cloneValue = (newObj, oldObj) => {
      for (let key in newObj) {
        newObj[key] = oldObj[key];
      }
    };
    this.setDataList = (index, data) => {
      //数组中变更数据，重新赋值及响应
      const { page, tableData, dataSource, selectKeys, selectObjs } = this;
      let idx = page.updateIndex(index) - 1;
      tableData[index] = dataSource[idx] = data;
      const objIdx = selectKeys.indexOf(data.id);
      if (objIdx > -1) {
        selectObjs[objIdx] = dataSource[idx];
      }
    };
    this.delDataList = (id, index) => {
      //数组中删除数据，重新赋值吸响应
      const { page, tableData, dataSource, selectKeys, selectObjs } = this;
      let idx = page.updateIndex(index) - 1;
      dataSource.splice(idx, 1);
      const objIdx = selectKeys.indexOf(id);
      this.selectDel(objIdx);
    };
  }
  shiftRow(newRow = {}) {
    //在前面插入一行newRow数据并且更新
    const { tableData, dataSource, page } = this;
    if (dataSource.length > 0) {
      dataSource.unshift({ ...newRow });
    } else {
      dataSource.push({ ...newRow });
    }
    page.updateTotalPage();
    page.update(1);
    this.selectIsAll();
  }
}

import { Message, MessageBox } from "element-ui";
export class FormVerify {
  constructor(array = []) {
    this.array = array;
    this.rulesObj = {};
    this.isFile = (val, msg = "请上传文件") => {
      //文件列表
      return val?.length > 0 ? true : msg;
    };
    this.isList = (val, msg = "列表为空") => {
      //列表
      return val?.length > 0 ? true : msg;
    };
    this.isEmpty = (val, msg = "不能为空") => {
      //空值
      console.log("val-isEmpty", typeof val, val);
      return val ? true : msg;
    };
    this.isEmail = (val, msg = "邮箱格式不正确") => {
      //邮箱
      let reg =
          /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/;
      return reg.test(val) ? true : msg;
    };
    this.isMobile = (val, msg = "手机号码格式不正确") => {
      //手机
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      return reg.test(val) ? true : msg;
    };
    this.isIdCard = (val, msg = "身份证号码格式不正确") => {
      //身份证号码
      let reg =
          /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return reg.test(val) ? true : msg;
    };
    this.isBankCard = (val, msg = "银行卡号格式不正确") => {
      //银行卡号
      let reg = /^[0-9]{9,18}$/;
      return reg.test(val) ? true : msg;
    };
    this.isString = (val, msg = "格式不正确") => {
      //英文加数字
      let reg = /^[0-9a-zA-Z]+$/;
      return reg.test(val) ? true : msg;
    };
    this.isNumber = (val, msg = "非数字类型") => {
      //数字
      console.log(`input-number:值:${val},类型：${typeof val}`);
      //let reg =  /^[0-9]+.?[0-9]*$/
      return typeof val === "number" ? true : msg;
    };
    this.isMin = (val, msg = "小", min = 6) => {
      if (typeof val == "number") {
        //数字类型
        return val >= min ? true : msg;
      } else {
        //字符串--最小值
        return val.length >= min ? true : msg;
      }
    };
    this.isMax = (val, msg = "大", max = 20) => {
      //最大值
      console.log("typeof (val)", typeof val, val);
      if (typeof val == "number") {
        console.log("number", val, max);
        //数字类型
        return val <= max ? true : msg;
      } else {
        //字符串--最大值
        return val.length <= max ? true : msg;
      }
    };
    this.isEqual = (val, msg = "不相等", target = "") => {
      //是否相等
      return val === target ? true : msg;
    };
    this.isFnsku = (val, msg = "格式不正确") => {
      //英文加数字加-加_
      let reg = /^[a-zA-Z0-9_-]+$/;
      return reg.test(val) ? true : msg;
    };
  }
  rules(array = [], target = {}) {
    let isTrue = true;
    keysfor: for (let k in array) {
      let obj = array[k];
      for (let i in obj.keys) {
        let key = obj.keys[i];
        let msg = "";
        msg = this[key](
            obj?.value ?? target[obj?.key ?? k],
            obj.msg[i],
            key === "isMin" ? obj.min : obj.max ?? obj.target ?? undefined
        );
        if (msg !== true) {
          Message({
            message: msg,
            type: "error",
          });
          console.warn("rules-error", key);
          isTrue = false;
          break keysfor;
        }
      }
    }
    if (!isTrue) {
      throw false;
    }
  }
  formRules(array = []) {
    //将自定义校验转为el-格式校验
    let rules = {};
    for (let k in array) {
      if (array[k].keys.includes("isEmpty")) {
        let idx = array[k].keys.indexOf("isEmpty");
        rules[k] = [
          { required: true, message: array[k].msg[idx], trigger: "blur" },
        ];
      }
      if (array[k].keys.includes("isNumber")) {
        let idx = array[k].keys.indexOf("isNumber");
        rules[k] = [
          { required: true, message: array[k].msg[idx], trigger: "blur" },
        ];
      }
    }
    return rules;
  }
}

import axios from "axios"
export class CreatedUrl {
  static openUrl = (url) => {
    const a = document.createElement("a");
    a.target = "_blank";
    a.style.display = "none"; //隐藏,没必要展示出来
    url = url.replace('http:','https:')
    a.href = url;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href); // 释放URL 对象
    document.body.removeChild(a); //完成移除
  };
  static bolbDown = (_blob, name) => {
    const nowTimer = new Date().getTime();
    const blob = new Blob([_blob]); //处理文档流
    const fileName = nowTimer + name;
    const a = document.createElement("a");
    a.download = fileName;
    //a.setAttribute("download", fileName); //下载的文件名以及文件格式
    a.target = "_blank";
    a.style.display = "none"; //隐藏,没必要展示出来
    a.href = URL.createObjectURL(blob);

    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href); // 释放URL 对象
    document.body.removeChild(a); //下载完成移除

  };
  static urlDown = async (url, name) => {
    const axiosService = axios.create({
      timeout: 60000,     // 请求超时时间
      // withCredentials: false,
    })
    const _blob = await axiosService({
      method: 'get',
      url: url,
      responseType: "blob",
      ['headers.Authorization']: ''
    }).then(res => {
      this.bolbDown(res.data, name)
    })

  }
  static openPdf = async (url, filename = 'preview.pdf') => {
    const newWin = window.open('about:blank');
    if (!newWin) {
      this.openUrl(url);
      return;
    }
    newWin.document.title = filename; // 预设标题
    try {
      const axiosService = axios.create({
        timeout: 60000,
      })
      const res = await axiosService({
        method: 'get',
        url: url.replace('http:', 'https:'),
        responseType: 'blob',
      })
      const blob = new Blob([res.data], { type: 'application/pdf' })
      const objectUrl = URL.createObjectURL(blob)
      
      // 使用 iframe 嵌入并设置标题，添加自定义下载按钮以确保文件名正确
      const safeFilename = filename.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      newWin.document.write(`
        <html>
          <head>
            <title>${safeFilename}</title>
            <style>
              body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; background: #525659; font-family: sans-serif; }
              .header {
                height: 40px;
                background-color: #323639;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 16px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                color: #f1f1f1;
                font-size: 14px;
              }
              .filename {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 60%;
              }
              .btn {
                background-color: #323639;
                color: #f1f1f1;
                border: 1px solid #666;
                padding: 4px 12px;
                border-radius: 4px;
                cursor: pointer;
                font-size: 13px;
                transition: background 0.2s;
              }
              .btn:hover {
                background-color: #45494d;
              }
              iframe { width: 100%; height: calc(100% - 40px); border: none; display: block; }
            </style>
          </head>
          <body>
            <div class="header">
              <span class="filename">${safeFilename}</span>
              <button class="btn" onclick="downloadPdf()">Download</button>
            </div>
            <iframe src="${objectUrl}" type="application/pdf"></iframe>
            <script>
              function downloadPdf() {
                const a = document.createElement('a');
                a.href = "${objectUrl}";
                a.download = "${safeFilename}";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }
            </script>
          </body>
        </html>
      `);
      newWin.document.close();
    } catch (e) {
      newWin.location.href = url.replace('http:', 'https:')
    }
  };
}
